// returns date in format yyy-mm-dd from Date object

const formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear().toString().substr(-4);

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (year.length == 1) year = '000' + year;
    if (year.length == 2) year = '00' + year;
    if (year.length == 3) year = '0' + year;

    return [year, month, day].join('-');
}

export default formatDate



// WEBPACK FOOTER //
// ./src/scripts/reusable/format-date.js